import React from "react";
import locationimage from "../../assets/location-image.jpg";

export interface ScreenStyles {
  backgroundColor: string;
  textColor: string;
  buttonColor: string;
  buttonLabelColor: string;
}

interface LocationScreenProps {
  styles: ScreenStyles;
  onNext?: () => void;   // chama quem controla a navegação
}

const LocationScreen: React.FC<LocationScreenProps> = ({ styles, onNext }) => (
  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
    <div style={{ textAlign: "center", marginBottom: 24 }}>
      <img src={locationimage} alt="location" style={{ maxWidth: "100%" }} />
    </div>

    <p style={{ color: styles.textColor, fontWeight: 600, fontSize: 16, marginBottom: 8 }}>
      Compartilhe sua localização
    </p>
    <p style={{ color: styles.textColor, fontSize: 14, marginBottom: 24, textAlign: "justify" }}>
      Solicitamos essa permissão para aumentar a segurança da sua conta e das suas apostas
    </p>

    <button
      onClick={onNext}
      style={{
        width: "100%",
        padding: "12px 0",
        backgroundColor: styles.buttonColor,
        border: "none",
        borderRadius: 30,
        color: styles.buttonLabelColor,
        fontWeight: 600,
        fontSize: 16,
      }}
    >
      Compartilhar
    </button>

    <p
      style={{
        textAlign: "center",
        marginTop: 12,
        color: styles.textColor,
        fontWeight: 500,
      }}
    >
      Não Compartilhar
    </p>
  </div>
);

export default LocationScreen;
